import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router";
import {useAuth} from "../context/authContext.tsx";
import {loginLService} from "../services/employee.ts";
import {useAuthOTP} from "../context/auth/authOtpContext.tsx";
import { getAuthenticatedHomeRoute } from "../utils/auth.ts";
import { digitalOceanImageUrl } from "../utils/digitalOcean.ts";

const Waiting = () => {
    const {email} = useParams();
    const [errors, setErrors] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const {employeeI, authReady} = useAuth();
    const {setEmailOtp} = useAuthOTP();

    const navigate = useNavigate();

    useEffect(() => {
        if (!authReady) {
            return;
        }

        if (employeeI) {
            navigate(getAuthenticatedHomeRoute(employeeI), {replace: true})
            return;
        }
        if (!email) {
            setErrors("Invalid email address")
            navigate("/login", { replace: true });
            return;
        }

        setLoading(true);
        loginLService({email: `${email}@kiiramotors.com`}).then((res) => {
            if(res.status === 200) {
                setLoading(false);
                setEmailOtp(`${email}@kiiramotors.com`);
                navigate("/otp", {replace: true})
            }
        }).catch((err) => {
            setErrors(err.response.data.error)
            setLoading(false);
            navigate("/login", { replace: true });
            console.error(err)
        });
    }, [authReady, email, employeeI, navigate, setEmailOtp]);

    // Custom Bouncy Loading Animation Component
    const BouncyLoadingAnimation = () => {
        return (
            <div className="flex items-center justify-center space-x-2">
                <div className="w-4 h-4 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                <div className="w-4 h-4 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                <div className="w-4 h-4 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                <div className="w-4 h-4 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '450ms' }}></div>
                <div className="w-4 h-4 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '600ms' }}></div>
            </div>
        );
    };

    return (
        <div className="w-full min-h-screen flex items-center justify-center relative bg-cover bg-center" 
             style={{ backgroundImage: `url('${digitalOceanImageUrl("assets/images/_99A0320.JPG")}')` }}>
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-blue-900/40"></div>
            
            {/* Loading overlay */}
            {loading && (
                <div className="fixed inset-0 w-full h-full flex items-center justify-center bg-black/70 z-10">
                    <div className="backdrop-blur-md bg-black/30 p-8 rounded-xl shadow-lg flex flex-col items-center">
                        <img
                            src={digitalOceanImageUrl("assets/images/logo.png")}
                            alt="KMC Logo"
                            className="w-32 h-auto mb-6"
                        />
                        <div className="text-white text-lg mb-6">
                            Processing your request...
                        </div>
                        <BouncyLoadingAnimation />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Waiting;
